import React from 'react'
import { Text, SummaryExercise, Heading } from 'components/library'
import pdf from './assets/5c8a1c4bfe36da2d5e24d52d-1555062941736-H2_Standaard_regels_en_procedures_in_de_praktijk_SLEEP.pdf'

const Intro = props => (
	<div>
		<Text><strong>In dit hoofdstuk leer je:</strong></Text>
		<ul style={{marginTop: '0'}}>
			<li>de regels en procedures van het standaard sleepproces;</li>
			<li>de regels en procedure voor het kruisen van een start- en landingsbaan;</li>
			<li>de regels en procedures voor specifieke locaties in het landingsterrein. </li>
		</ul>
	</div>
)

const Summary = props => (
	<div>
		<div>
			<ul style={{marginTop: '0'}}>
				<li>de regels en procedure van het standaard sleepproces;</li>
				<li>de regels en procedure voor het kruisen van een start- en landingsbaan;</li>
				<li>de regels en procedures voor het slepen van en naar Schiphol-Oost;</li>
				<li>de procedure voor het slepen voor kop 09 langs via Rijbaan Charlie of Delta.</li>
			</ul>
		</div>
		<div>
			<SummaryExercise link={pdf}>
				<Heading h3>Standaard regels en procedures in de praktijk</Heading>
		    <ul style={{marginTop: '0'}}>
		      <li>Ga samen met je instructeur kijken bij een standaard sleepbeweging, herken je de stappen die je in de video gezien hebt?</li>
		      <li style={{margin: '3rem 0'}}>Vraag aan je instructeur of je mee mag met een sleepbeweging waarbij een baan gekruist moet worden. Herken je de stappen die je in de video hebt gezien?</li>
		      <li> Vraag aan je instructeur of jullie voor Kop 09 langs kunnen rijden via rijbaan C of D. Snap je waarom hier extra regels gelden?</li>
		    </ul>
			</SummaryExercise>
		</div>
  </div>
)

export { Intro, Summary }



// WEBPACK FOOTER //
// ./src/content/chapters/02/index.js